import React from "react";
import { UserLevel } from "utils/constant";

export default function TableComponent({
  currentLevel,
  reportsData,
  tableRef,
  reportInfo,
}) {
  const levelName =
    currentLevel === UserLevel.National
      ? "Nasional"
      : currentLevel === UserLevel.Province
        ? "Provinsi"
        : currentLevel === UserLevel.District
          ? "Kabupaten/Kota"
          : "Puskesmas";

  const faskesName = (() => {
    const data = reportInfo?.fasyankes;
    const parts = data?.split(",");
    const names = parts?.map((p) => p?.split("|")[1]);
    return names?.join(", ");
  })();

  const renderTableByLevel = () => {
    switch (currentLevel) {
      case UserLevel.Fasyankes: {
        // Filter out total row for data display, and find the total row for footer
        const dataRows = reportsData?.filter((row) => !row.is_total_row) ?? [];
        const totalRow = reportsData?.find((row) => row.is_total_row);

        return (
          <>
            <thead>
              <tr>
                <th>No.</th>
                <th>Nama Desa</th>
                <th>Jumlah Penduduk</th>
                <th>Jumlah Total Sasaran Rumah</th>
                <th>Jumlah Rumah Yang Diseprot</th>
                <th>Tanggal IRS</th>
                <th>Jenis Insektisida</th>
                <th>Jumlah Insektisida Yang Digunakan</th>
                <th>Satuan Insektisida</th>
                <th>Jumlah Total Sasaran Rumah Tingkat Desa</th>
                <th>Jumlah Rumah Yang di Semprot Tingkat Desa</th>
                <th>Nama Dusun</th>
                <th>Jumlah Penduduk Di Dusun Tersebut</th>
                <th>Jumlah Total Sasaran Rumah Tingkat Dusun</th>
                <th>Jumlah Rumah Yang Disemprot Tingkat Dusun</th>
              </tr>
            </thead>
            <tbody>
              {dataRows?.length ? (
                dataRows.map((row, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{row?.nama_desa ?? "-"}</td>
                    <td>{row?.jumlah_penduduk_desa ?? "0"}</td>
                    <td>
                      {Number(row?.jumlah_total_sasaran_rumah_desa)}
                    </td>
                    <td>{row?.jumlah_rumah_disemprot_desa ?? "-"}</td>
                    <td>{row?.irs_date ?? "-"}</td>
                    <td>{row?.insecticide_type ?? "-"}</td>
                    <td>{row?.total_insecticide ?? "-"}</td>
                    <td>{row?.total_insecticide_unit ?? "-"}</td>
                    <td>{row?.jumlah_total_sasaran_rumah_desa ?? "0"}</td>
                    <td>{row?.jumlah_rumah_disemprot_desa ?? "0"}</td>
                    <td>{row?.nama_dusun ?? "0"}</td>
                    <td>{row?.jumlah_penduduk_dusun ?? "-"}</td>
                    <td>{row?.jumlah_total_sasaran_rumah_dusun ?? "0"}</td>
                    <td>{row?.jumlah_rumah_disemprot_dusun ?? "0"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={15}>Tidak Ada Data</td>
                </tr>
              )}
            </tbody>
            {dataRows?.length > 0 && totalRow && (
              <tfoot>
                <tr
                  style={{
                    fontWeight: "bold",
                    backgroundColor: "#43766C",
                  }}
                >
                  <td style={{ color: "#FFF" }} colSpan={2}>
                    Total
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {totalRow?.jumlah_penduduk_desa ?? "0"}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {Number(totalRow?.jumlah_total_sasaran_rumah_desa ?? 0)}
                    {/* {totalRow?.jumlah_total_sasaran_rumah_desa ?? "0"} */}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {totalRow?.jumlah_rumah_disemprot_desa ?? "0"}
                  </td>
                  <td style={{ color: "#FFF" }}>-</td>
                  <td style={{ color: "#FFF" }}>-</td>
                  <td style={{ color: "#FFF" }}>
                    {totalRow?.total_insecticide ?? "-"}
                  </td>
                  <td style={{ color: "#FFF" }}>-</td>
                  <td style={{ color: "#FFF" }}>
                    {totalRow?.jumlah_total_sasaran_rumah_desa ?? "0"}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {totalRow?.jumlah_rumah_disemprot_desa ?? "0"}
                  </td>
                  <td style={{ color: "#FFF" }}>-</td>
                  <td style={{ color: "#FFF" }}>
                    {totalRow?.jumlah_penduduk_dusun ?? "-"}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {totalRow?.jumlah_total_sasaran_rumah_dusun ?? "0"}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {totalRow?.jumlah_rumah_disemprot_dusun ?? "0"}
                  </td>
                </tr>
              </tfoot>
            )}
          </>
        );
      }

      case UserLevel.District:
        return (
          <>
            <thead>
              <tr>
                <th rowSpan="3">No</th>
                <th rowSpan="3">Kabupaten/Kota</th>
                <th rowSpan="3">Fasyankes</th>
                <th rowSpan="3">Jumlah Desa</th>
                <th rowSpan="3">Jumlah Desa Dilakukan IRS</th>
                <th colSpan="8">
                  Jumlah Insektisida Yang Digunakan Berdasarkan Jenisnya
                </th>
                <th rowSpan="3">Jumlah Total Sasaran Rumah</th>
                <th rowSpan="3">Jumlah Rumah Yang di Semprot</th>
                <th rowSpan="3">Jumlah Dusun</th>
                <th rowSpan="3">Jumlah Dusun Dilakukan IRS</th>
              </tr>
              <tr>
                <th colSpan="2">Organophospate</th>
                <th colSpan="2">Karbamat</th>
                <th colSpan="2">Piretroid</th>
                <th colSpan="2">Neonikotinoid</th>
              </tr>
              <tr>
                <th>Kg</th>
                <th>Liter</th>
                <th>Kg</th>
                <th>Liter</th>
                <th>Kg</th>
                <th>Liter</th>
                <th>Kg</th>
                <th>Liter</th>
              </tr>
            </thead>
            <tbody>
              {reportsData?.length ? (
                reportsData.map((row, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{row?.nama_kabupaten ?? "-"}</td>
                    <td>{row?.nama_fasyankes ?? "-"}</td>
                    <td>{row?.jumlah_desa ?? "0"}</td>
                    <td>{row?.jumlah_desa_dilakukan_irs ?? "0"}</td>
                    <td>{row?.organophosphate_kg ?? "0"}</td>
                    <td>{row?.organophosphate_liter ?? "0"}</td>
                    <td>{row?.karbamat_kg ?? "0"}</td>
                    <td>{row?.karbamat_liter ?? "0"}</td>
                    <td>{row?.piretroid_kg ?? "0"}</td>
                    <td>{row?.piretroid_liter ?? "0"}</td>
                    <td>{row?.neonikotinoid_kg ?? "0"}</td>
                    <td>{row?.neonikotinoid_liter ?? "0"}</td>
                    <td>{row?.jumlah_total_sasaran_rumah ?? "0"}</td>
                    <td>{row?.jumlah_rumah_disemprot ?? "0"}</td>
                    <td>{row?.jumlah_dusun ?? "0"}</td>
                    <td>{row?.jumlah_dusun_dilakukan_irs ?? "0"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={17}>Tidak Ada Data</td>
                </tr>
              )}
            </tbody>
            {reportsData?.length > 0 && (
              <tfoot>
                <tr
                  style={{
                    fontWeight: "bold",
                    backgroundColor: "#43766C",
                  }}
                >
                  <td style={{ color: "#FFF" }} colSpan={3}>
                    Total
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) => sum + (parseInt(row?.jumlah_desa) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum + (parseInt(row?.jumlah_desa_dilakukan_irs) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.organophosphate_kg) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.organophosphate_liter) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) => sum + (parseFloat(row?.karbamat_kg) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.karbamat_liter) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.piretroid_kg) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.piretroid_liter) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.neonikotinoid_kg) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.neonikotinoid_liter) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum + (parseInt(row?.jumlah_total_sasaran_rumah) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum + (parseInt(row?.jumlah_rumah_disemprot) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) => sum + (parseInt(row?.jumlah_dusun) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum + (parseInt(row?.jumlah_dusun_dilakukan_irs) || 0),
                      0,
                    )}
                  </td>
                </tr>
              </tfoot>
            )}
          </>
        );

      case UserLevel.Province:
        return (
          <>
            <thead>
              <tr>
                <th rowSpan="3">No</th>
                <th rowSpan="3">Provinsi</th>
                <th rowSpan="3">Kabupaten/Kota</th>
                <th rowSpan="3">Jumlah Desa</th>
                <th rowSpan="3">Jumlah Desa Dilakukan IRS</th>
                <th colSpan="8">
                  Jumlah Insektisida Yang Digunakan Berdasarkan Jenisnya
                </th>
                <th rowSpan="3">Jumlah Total Sasaran Rumah</th>
                <th rowSpan="3">Jumlah Rumah Yang di Semprot</th>
                <th rowSpan="3">Jumlah Dusun</th>
                <th rowSpan="3">Jumlah Dusun Dilakukan IRS</th>
              </tr>
              <tr>
                <th colSpan="2">Organophospate</th>
                <th colSpan="2">Karbamat</th>
                <th colSpan="2">Piretroid</th>
                <th colSpan="2">Neonikotinoid</th>
              </tr>
              <tr>
                <th>Kg</th>
                <th>Liter</th>
                <th>Kg</th>
                <th>Liter</th>
                <th>Kg</th>
                <th>Liter</th>
                <th>Kg</th>
                <th>Liter</th>
              </tr>
            </thead>
            <tbody>
              {reportsData?.length ? (
                reportsData.map((row, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{row?.nama_provinsi ?? "-"}</td>
                    <td>{row?.nama_kabupaten ?? "-"}</td>
                    <td>{row?.jumlah_desa ?? "0"}</td>
                    <td>{row?.jumlah_desa_dilakukan_irs ?? "0"}</td>
                    <td>{row?.organophosphate_kg ?? "0"}</td>
                    <td>{row?.organophosphate_liter ?? "0"}</td>
                    <td>{row?.karbamat_kg ?? "0"}</td>
                    <td>{row?.karbamat_liter ?? "0"}</td>
                    <td>{row?.piretroid_kg ?? "0"}</td>
                    <td>{row?.piretroid_liter ?? "0"}</td>
                    <td>{row?.neonikotinoid_kg ?? "0"}</td>
                    <td>{row?.neonikotinoid_liter ?? "0"}</td>
                    <td>{row?.jumlah_total_sasaran_rumah ?? "0"}</td>
                    <td>{row?.jumlah_rumah_disemprot ?? "0"}</td>
                    <td>{row?.jumlah_dusun ?? "0"}</td>
                    <td>{row?.jumlah_dusun_dilakukan_irs ?? "0"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={17}>Tidak Ada Data</td>
                </tr>
              )}
            </tbody>
            {reportsData?.length > 0 && (
              <tfoot>
                <tr
                  style={{
                    fontWeight: "bold",
                    backgroundColor: "#43766C",
                  }}
                >
                  <td style={{ color: "#FFF" }} colSpan={3}>
                    Total
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) => sum + (parseInt(row?.jumlah_desa) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum + (parseInt(row?.jumlah_desa_dilakukan_irs) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.organophosphate_kg) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.organophosphate_liter) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) => sum + (parseFloat(row?.karbamat_kg) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.karbamat_liter) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.piretroid_kg) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.piretroid_liter) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.neonikotinoid_kg) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.neonikotinoid_liter) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum + (parseInt(row?.jumlah_total_sasaran_rumah) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum + (parseInt(row?.jumlah_rumah_disemprot) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) => sum + (parseInt(row?.jumlah_dusun) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum + (parseInt(row?.jumlah_dusun_dilakukan_irs) || 0),
                      0,
                    )}
                  </td>
                </tr>
              </tfoot>
            )}
          </>
        );

      default:
        return (
          <>
            <thead>
              <tr>
                <th rowSpan="3">No</th>
                <th rowSpan="3">Provinsi</th>
                <th rowSpan="3">Kabupaten/Kota</th>
                <th rowSpan="3">Jumlah Desa</th>
                <th rowSpan="3">Jumlah Desa Dilakukan IRS</th>
                <th colSpan="8">
                  Jumlah Insektisida Yang Digunakan Berdasarkan Jenisnya
                </th>
                <th rowSpan="3">Jumlah Total Sasaran Rumah</th>
                <th rowSpan="3">Jumlah Rumah Yang di Semprot</th>
                <th rowSpan="3">Jumlah Dusun</th>
                <th rowSpan="3">Jumlah Dusun Dilakukan IRS</th>
              </tr>
              <tr>
                <th colSpan="2">Organophospate</th>
                <th colSpan="2">Karbamat</th>
                <th colSpan="2">Piretroid</th>
                <th colSpan="2">Neonikotinoid</th>
              </tr>
              <tr>
                <th>Kg</th>
                <th>Liter</th>
                <th>Kg</th>
                <th>Liter</th>
                <th>Kg</th>
                <th>Liter</th>
                <th>Kg</th>
                <th>Liter</th>
              </tr>
            </thead>
            <tbody>
              {reportsData?.length ? (
                reportsData.map((row, idx) => (
                  <tr key={idx}>
                    <td>{idx + 1}</td>
                    <td>{row?.nama_provinsi ?? "-"}</td>
                    <td>{row?.nama_kabupaten ?? "-"}</td>
                    <td>{row?.jumlah_desa ?? "0"}</td>
                    <td>{row?.jumlah_desa_dilakukan_irs ?? "0"}</td>
                    <td>{row?.organophosphate_kg ?? "0"}</td>
                    <td>{row?.organophosphate_liter ?? "0"}</td>
                    <td>{row?.karbamat_kg ?? "0"}</td>
                    <td>{row?.karbamat_liter ?? "0"}</td>
                    <td>{row?.piretroid_kg ?? "0"}</td>
                    <td>{row?.piretroid_liter ?? "0"}</td>
                    <td>{row?.neonikotinoid_kg ?? "0"}</td>
                    <td>{row?.neonikotinoid_liter ?? "0"}</td>
                    <td>{row?.jumlah_total_sasaran_rumah ?? "0"}</td>
                    <td>{row?.jumlah_rumah_disemprot ?? "0"}</td>
                    <td>{row?.jumlah_dusun ?? "0"}</td>
                    <td>{row?.jumlah_dusun_dilakukan_irs ?? "0"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={17}>Tidak Ada Data</td>
                </tr>
              )}
            </tbody>
            {reportsData?.length > 0 && (
              <tfoot>
                <tr
                  style={{
                    fontWeight: "bold",
                    backgroundColor: "#43766C",
                  }}
                >
                  <td style={{ color: "#FFF" }} colSpan={3}>
                    Total
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) => sum + (parseInt(row?.jumlah_desa) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum + (parseInt(row?.jumlah_desa_dilakukan_irs) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.organophosphate_kg) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.organophosphate_liter) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) => sum + (parseFloat(row?.karbamat_kg) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.karbamat_liter) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.piretroid_kg) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.piretroid_liter) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.neonikotinoid_kg) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData
                      .reduce(
                        (sum, row) =>
                          sum + (parseFloat(row?.neonikotinoid_liter) || 0),
                        0,
                      )
                      .toFixed(0)}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum + (parseInt(row?.jumlah_total_sasaran_rumah) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum + (parseInt(row?.jumlah_rumah_disemprot) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) => sum + (parseInt(row?.jumlah_dusun) || 0),
                      0,
                    )}
                  </td>
                  <td style={{ color: "#FFF" }}>
                    {reportsData.reduce(
                      (sum, row) =>
                        sum + (parseInt(row?.jumlah_dusun_dilakukan_irs) || 0),
                      0,
                    )}
                  </td>
                </tr>
              </tfoot>
            )}
          </>
        );
    }
  };

  return (
    <div
      className="table-table-responsive"
      ref={tableRef}
    >
      <table>
        <tbody>
          <tr style={{ border: "none", padding: 0 }}>
            <th style={{ border: "none", paddingBottom: 0 }}>
              <h3>SISMAL v4, Laporan Rekap IRS {reportInfo?.periode}</h3>
            </th>
          </tr>
        </tbody>
      </table>

      <table>
        <tbody>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", padding: 0 }}>Level</th>
            <th style={{ border: "none", padding: 0 }}>: {levelName}</th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", padding: 0 }}>Provinsi</th>
            <th style={{ border: "none", padding: 0 }}>
              :{" "}
              {reportInfo?.province
                ? reportInfo.province.split("|")[1]
                : "Semua Provinsi"}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", padding: 0 }}>Kab/Kota</th>
            <th style={{ border: "none", padding: 0 }}>
              :{" "}
              {reportInfo?.district
                ? reportInfo.district.split("|")[1]
                : "Semua Kab/Kota"}
            </th>
          </tr>
          <tr style={{ border: "none" }}>
            <th style={{ border: "none", paddingTop: 0 }}>Fasyankes</th>
            <th style={{ border: "none", paddingTop: 0 }}>
              : {reportInfo?.fasyankes ? faskesName : "Semua Fasyankes"}
            </th>
          </tr>
        </tbody>
      </table>

      <table>{renderTableByLevel()}</table>
    </div>
  );
}
